import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { useProfile } from '../../../contexts/ProfileContext';

function ProtectedRoute({ children = null, requiresProfile = true }) {
  const { isAuthenticated } = useAuth();
  const { needsProfileSelection } = useProfile();
  const location = useLocation();

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If this route requires a profile and user needs to select one, redirect to profile selection
  // Don't redirect if we're already on the profile selection page
  if (requiresProfile && needsProfileSelection && location.pathname !== '/switch-profile') {
    return <Navigate to="/switch-profile" replace />;
  }

  // Render children for specific components or Outlet for nested routes
  return children || <Outlet />;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node,
  requiresProfile: PropTypes.bool,
};

export default ProtectedRoute;
